export const CreditCardUpgradeRoutes = {
    ROOT: "/cc-upgrade",
    PERSONAL_DATA: "/cc-upgrade/personal-data",
    SUMMARY: "/cc-upgrade/summary",
    SIGNING: "/cc-upgrade/signing",
    SUCCESS: "/cc-upgrade/success",
    NEW_PHONE: "/cc-upgrade/new-phone",
    NEW_ADDRESS: "/cc-upgrade/new-address",
    ERROR_UPGRADE_NOT_POSSIBLE: "/cc-upgrade/unavailable",
    PDF: "/cc-upgrade/pdf",
};



// WEBPACK FOOTER //
// ./src/components/creditCardUpgrade/CreditCardUpgradeRoutes.ts